import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/Account";

function bytesToBase64(bytes) {
    const binString = String.fromCodePoint(...bytes);
    return btoa(binString);
}

function base64Encoding(username, password) {
    const usernameEncoded = bytesToBase64(new TextEncoder().encode(username));
    const passwordEncoded = bytesToBase64(new TextEncoder().encode(password));
    return { email: usernameEncoded, abcd: passwordEncoded };
}

class AdminAuthService {
    login(username, password) {
        const { email, abcd } = base64Encoding(username, password);
        return axios.post(`${BASIC_API}/AdminLogin?email=${email}&abcd=${abcd}`, {
            email,
            abcd
        });
    }
    logout() {
        localStorage.clear();
    }
    getCurrentUser() {
        return JSON.parse(localStorage.getItem("biodnd_admin_token"));
    }
    forgetPassword(email) {
        return axios.post(`${BASIC_API}/Admin/ForgetPassword`, {
            email
        });
    }
    resetPassword(token, newPKey, newPKeyConfirm) {
        return axios.post(`${BASIC_API}/Admin/ResetPassword`, {
            token,
            newPKey,
            newPKeyConfirm
        });
    }
    getProfile() {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/Admin`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
    update(requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Admin/Update`,
            requestBody,
            {
                headers: {Authorization: `Bearer ${token}`}
            }
        );
    }
}

const NewAdminAuthService = new AdminAuthService();
export default NewAdminAuthService;